import React from "react";

import { useAppContext } from "@app/helpers/hooks";
import {
  aboutPartnersUrl,
  aboutUrl,
  blogUrl,
  helpUrl,
  impressumUrl
} from "@app/services/url-builders/company-pages-url-builder";

import { LinksWithTitleBlock } from "../links-with-title";

export const LightCompanyBlock = () => {
  const { locale, translator } = useAppContext();

  const links = [
    {
      link: aboutUrl(locale),
      label: translator.t("!layout.footer.about")
    },
    {
      link: aboutPartnersUrl(locale),
      label: translator.t("!layout.footer.partner-with-us")
    },
    {
      link: blogUrl(locale),
      label: translator.t("!layout.footer.blog")
    },
    {
      link: helpUrl(locale),
      label: translator.t("!layout.footer.help")
    }
  ];

  if (locale === "de") {
    links.push({
      link: impressumUrl(locale),
      label: translator.t("!impressum")
    });
  }

  const title = translator.t("!footer.company");

  return <LinksWithTitleBlock title={title} links={links} />;
};
